import { computed, useStore } from '@nuxtjs/composition-api'

export const useKeycloakAuthModalParams = () => {
  const store = useStore()
  return computed(() => {
    const modalData = store.getters['settings/getAuthModalData']
    return {
      'modal-auth-lkdms': {
        src: modalData['modal-auth-lkdms']?.kcFrameSrc,
        redirectUrl: modalData.lkRedirectUrl,
      },
      'modal-auth-appeal': {
        src: modalData['modal-auth-appeal']?.kcFrameSrc,
        redirectUrl: modalData.lkRedirectUrl + '/appeals#isSentAppeals',
      },
    }
  })
}
